import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useParallaxRef } from '@/utils/parallax';
import { AnimatedGradientText } from '@/components/ui/animated-gradient-text';
import ServicesCategorySection from '@/components/ServicesCategorySection';
import ServicesWhoSection from '@/components/ServicesWhoSection';
import ServicesGapSection from '@/components/ServicesGapSection';
import ServicesFrameworkSection from '@/components/ServicesFrameworkSection';
import ServicesProcessSection from '@/components/ServicesProcessSection';
import ServicesPackagesSection from '@/components/ServicesPackagesSection';
import ServicesComparisonSection from '@/components/ServicesComparisonSection';
import ServicesPortfolioSection from '@/components/ServicesPortfolioSection';
import ServicesActionsSection from '@/components/ServicesActionsSection';
import ServicesTestimonialsSection from '@/components/ServicesTestimonialsSection';
import ServicesFAQSection from '@/components/ServicesFAQSection';
import ServicesMeetAdamSection from '@/components/ServicesMeetAdamSection';
import ServicesFinalCTASection from '@/components/ServicesFinalCTASection';

export default function Services() {
  // Parallax refs
  const heroTitleRef = useParallaxRef({ speed: -0.22, axis: 'y', maxTranslate: 108 });
  const heroSubRef = useParallaxRef({ speed: -0.32, axis: 'y', maxTranslate: 128 });

  return (
    <>
      <Helmet>
        <title>Services - Attain Domains</title>
        <meta
          name="description"
          content="Turn your premium domain into a successful business. Get expert help after you buy or lease."
        />
      </Helmet>

      <div className="flex flex-col min-h-screen bg-background">
        {/* Hero Section */}
        <section className="relative z-0 w-full overflow-hidden min-h-[70vh] md:min-h-[80vh] pt-32 pb-24 flex items-center">
          {/* Animated wave background */}
          <img
            src="/media/services/service-page-background.svg"
            alt=""
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-cover pointer-events-none select-none"
          />

          <div className="container mx-auto px-4 relative z-20">
            <div className="max-w-6xl mx-auto text-center stagger-fade-1">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 text-white drop-shadow-lg">
                <span ref={heroTitleRef as any} className="block">
                  Turn Your{' '}
                  <Link to="/domains" className="inline-block hover:opacity-90 transition-opacity">
                    <AnimatedGradientText colorFrom="#60a5fa" colorTo="#ffffff" className="text-5xl md:text-6xl lg:text-7xl font-bold">
                      Domain
                    </AnimatedGradientText>
                  </Link>{' '}
                  Into A Successful Business
                </span>
                <span
                  ref={heroSubRef as any}
                  className="mt-2 block text-2xl md:text-3xl lg:text-4xl text-white/85 font-normal"
                >
                  Get expert help after you buy or lease
                </span>
              </h1>
            </div>
          </div>
        </section>

        {/* Explore by Category Section - Services Page Only */}
        <ServicesCategorySection />

        {/* Who This Is For Section */}
        <ServicesWhoSection />

        {/* The Gap Section */}
        <ServicesGapSection />

        {/* Success Framework Section */}
        <ServicesFrameworkSection />

        {/* How We'll Work Together Section */}
        <ServicesProcessSection />

        {/* Packages & Pricing Section */}
        <ServicesPackagesSection />

        {/* Comparison Table Section */}
        <ServicesComparisonSection />

        {/* Portfolio & Results Section */}
        <ServicesPortfolioSection />

        {/* Two Action Cards Section */}
        <ServicesActionsSection />

        {/* Testimonials / Social Proof Section */}
        <ServicesTestimonialsSection />

        {/* FAQ Section */}
        <ServicesFAQSection />

        {/* Meet Adam Section */}
        <ServicesMeetAdamSection />

        {/* Final CTA Section */}
        <ServicesFinalCTASection />
      </div>
    </>
  );
}
